import React from 'react'
import classnames from 'classnames'

const ImageIcon = ({ className, iconImg, iconImgAlt }) => (
  <img
    className={classnames('w-6 absolute top-1/2 transform -translate-y-1/2 z-10', className)}
    src={iconImg}
    alt={iconImgAlt}
  />
)

export default ImageIcon
